import { render, staticRenderFns } from "./PurchaseResources.vue?vue&type=template&id=08fed11a&scoped=true&"
import script from "./PurchaseResources.vue?vue&type=script&lang=js&"
export * from "./PurchaseResources.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseResources.vue?vue&type=style&index=0&id=08fed11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fed11a",
  null
  
)

export default component.exports